/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
/* eslint-disable security/detect-unsafe-regex */

import React, { useContext, useState } from 'react';
import AnimatedList from '../../../../../components/Animation/AnimatedList';
import AnimatedButton from '../../../../../components/Animation/AnimatedButton';
import AnimatedModel from '../../../../../components/Animation/AnimatedModel';
import ConfirmationPrompt from '../../../../../components/ConfirmationPrompt';
import GlobalContext from '../../../../../components/Context/GloablContext';
import { dataService } from '../../../../../services/data.services';
import TextSection from '../../../../../components/ToolTip/TextSection';
import { GetBranchId } from '../../../../../CommonMethods/GetBranchId';
import { useNavigate } from 'react-router-dom';

const TableBody = ({
    lastIndex,
    tableData, 
    indexNum, 
    searchParams,
    selectedIndex, 
    setSelectedIndex, 
    selectedRef, 
    setToastErrorMessage,
    getListData, setLoading,email }) => {
    const {setToastmessage, isInactiveBranch} =  useContext(GlobalContext);

    const location = useNavigate()
    const urlParams = new URLSearchParams(window.location.search);

    /**
     * This function sets the confirmation state to activate or deactivate an item in a table.
     */
    const [activateOpen, setActivateOpen] = useState(false);
    const [activateButtonLoading, setActivateButtonLoading] = useState(false)

    const handleConformationClick = () => {
        setActivateOpen(!activateOpen)
    }
    const [selectedButtonIndex, setSelectedButtonIndex] = useState(null)

    /**
     * The function `handelActionButton` sets the selected index to the provided index number.
     */
    
    const handelActionButton = async(indexNum) =>{
        setSelectedIndex(indexNum)
       
    }
    const [hover, sethover] = useState('')
    const [hoverIndex, sethoverIndex] = useState(null)
    const [selectedErrorMessage, setSelectedErrorMessage] = useState(null)
    const handleOnCLickActivate = async () => {
        setActivateButtonLoading(true);
        try {
            let body = { }
            body = {
                "status": "inactive",
            }
            let endpoint= `inventory/${tableData._id}`
            const response = await dataService.PatchAPI(body,endpoint);
            handleConformationClick();
            setActivateButtonLoading(false);
            setToastmessage(`Inventory item deactivated successfully`);
            getListData()

        } catch (error) {
            handleConformationClick();
            setActivateButtonLoading(false);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        }
    }
   
    const handleStatus = (key) => {
        let val = {}
        switch (tableData?.status) {
        case "active":
            val = {status : "Active", img: "successDot.svg", color : "bg-[#C5FFD5]"}
            break;
        case "inactive":
            val = {status : "Inactive", img: "inactive-Dot.svg", color : "bg-[#B3BBC1]"}
            break;
        
        default:
            break;
        }
        return val[key]
    }
    const sellingPrice = tableData?.selling_price;

    const formattedSellingPrice = typeof sellingPrice === 'string' && sellingPrice !== ""
        ? (
            parseFloat(sellingPrice) % 1 === 0
                ? parseFloat(sellingPrice).toFixed(2)
                : parseFloat(sellingPrice) % 1 === 0.7
                    ? parseFloat(sellingPrice).toFixed(1) + '0'
                    : parseFloat(sellingPrice).toFixed(2)
        )
        : sellingPrice;
    const [value, setValue] = useState(formattedSellingPrice);

    const handleChange = (e) => {
        let inputValue = e.target.value;
        // Remove any non-numeric and non-dot characters
        inputValue = inputValue.replace(/[^\d.]/g, '');
    
        // Limit to a maximum length of 5 characters (including decimal and decimals)
        if (inputValue?.length <= 13) {
            // Allow only up to 2 decimal places
            const regex = /^(\d{1,10}(\.\d{0,2})?)?$/;
            if (regex.test(inputValue)) {
                setValue(inputValue);
            }
        }
    };
    const onEditCancel = () => {
        setSelectedButtonIndex(null)
        setSelectedErrorMessage(null)
        setValue(formattedSellingPrice);
    }
    const onEditSubmit = async () => {
        setSelectedErrorMessage(null)
        if(value === "") {
            setSelectedErrorMessage(indexNum)
            setToastErrorMessage("Please enter valid details")
            return
        }
        try {
            let endPoint = ""
            let body = {
                branch_id : await GetBranchId(),
                selling_price : value
            }
            endPoint = `inventory/${tableData._id}`
            const res = await dataService.PatchAPI(body,endPoint)
            setLoading(true)
            getListData()
            setToastmessage("Selling Price updated successfully")
            setSelectedButtonIndex(null);
        } catch (error){
            setSelectedErrorMessage(indexNum)
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong") 
        }
    }
    return (
        <>
            <AnimatedList
                cursorpointer={true}
                title={`View GRN Entries`}
                rowStatus={tableData.status === "active" ? true : false}
                keyItem={indexNum} 
                handleClick={(e)=>{
                    if (e.target.classList.contains('prevent-click')) {
                        return;
                    } else {
                        location(`/inventory-master/inventory-list/view-grn?${urlParams.toString()}&inventory_id=${tableData._id}
                                    &inventory_name=${tableData.item_name}&inventory_code=${tableData.item_code}`)
                    }
                }}
                child={
                    <>
                        <td class="text-start">{tableData.item_code || "-"}</td>
                        <td class="text-start">{tableData?.item_name || "-"}</td>
                        <td class="text-start">{tableData?.uom || "-"}</td>
                        <td class="text-end">{tableData?.total_available_quantity || "-"}</td>
                        <td class="text-end prevent-click">
                            <div className='prevent-click'><label className='prevent-click'></label>
                                <input
                                    id="selling_price"
                                    autoComplete="off"
                                    min="0"
                                    type="text" // Use text type to allow maxLength
                                    maxLength="13" // Limit total length to 5 characters
                                    value={value}
                                    onChange={handleChange}
                                    disabled={selectedButtonIndex !== indexNum}
                                    className={`text-end w-[100px] outline-0  border prevent-click ${selectedErrorMessage === indexNum ? "border-[#F04438]" : selectedButtonIndex === indexNum ? "  border-[#D0D5DD]"  : "border-none"}`}
                                    style={{'background-color':'revert'}}
                                />
                            </div>
                        </td>
                        <td className='items-start prevent-click' style={{'padding-left':'0px'}}>
                            {selectedButtonIndex === indexNum &&
                                <div className='flex prevent-click'>
                                    <div className='relative prevent-click'>
                                        <>{hover === 'update' && (hoverIndex === indexNum) &&
                                        <div className='absolute  top-[45px] -left-5 prevent-click'>
                                            <TextSection text='Update' show from={'academicreports'} />
                                        </div>}
                                        </>
                                        <button id = {indexNum + "update"} onMouseEnter={() => { sethover('update'), sethoverIndex(indexNum) }} onMouseLeave={() => { sethover(''), sethoverIndex(null) }} type="button" class="px-[3px] relative prevent-click" onClick={() => onEditSubmit()}>
                                            <img loading="lazy" decoding="async"src="/images/otp-tick.svg" alt="img" class="w-4 h-4 prevent-click" />
                                        </button>
                                    </div>
                                    <div className='relative prevent-click'>
                                        <>{hover === 'Cancel' && (hoverIndex === indexNum) &&
                                        <div className='absolute  top-[45px] -left-4 prevent-click'>
                                            <TextSection text='Cancel' show from={'academicreports'} />
                                        </div>}
                                        </>
                                        <button type="button" onMouseEnter={()=>{sethover('Cancel'), sethoverIndex(indexNum)}} onMouseLeave={()=>{sethover(''), sethoverIndex(null)}} class="px-[3px] ml-1 relative prevent-click " onClick={()=>onEditCancel()}>
                                            <img loading="lazy" decoding="async" src="/images/file-remove.svg" alt="img" class="w-4 h-4 prevent-click"/>
                                        </button>
                                    </div>
                                </div>

                            }
                            {(tableData.status === "active" && selectedButtonIndex !== indexNum && !isInactiveBranch)&& 
                            <>
                                {hover === 'modify' && (hoverIndex === indexNum) &&
                                <div className='relative top-[45px] -left-12  prevent-click'>
                                    <TextSection text='Modify Selling Price' show from={'academicreports'} />
                                </div>}
                        
                                <div class="relative  prevent-click">
                                    <button 
                                        id="view" 
                                        class="pb-2 edit_value  prevent-click" 
                                        data-tooltip-target="panuploadInfo" 
                                        data-tooltip-trigger="hover" 
                                        data-tooltip-placement="top" 
                                        type="button" 
                                        disabled=""
                                        onMouseEnter={()=>{sethover('modify'), 
                                        sethoverIndex(indexNum)}} 
                                        onMouseLeave={()=>{sethover(''), sethoverIndex(null)}} 
                                        onClick={() => setSelectedButtonIndex(indexNum)}
                                    >
                                        <img loading="lazy" decoding="async" src="/images/offcanvasEditDetails.svg" alt="img" id="modify_attendance" class="w-4 h-4  prevent-click"/>
                                    </button>
                                </div>
                            </>
                            }
                        </td>
                        <td class="table-cell">
                            <div className='flex justify-center'>
                                <div className={`w-fit rounded ${handleStatus("color")} flex items-center justify-center py-1 px-2.5`}>
                                    <img loading="lazy" decoding="async" src={`/images/${handleStatus("img")}`} alt="icon"/>
                                    <span class="text-f7 font-normal text-[#031624] pl-1">{handleStatus("status")}</span>
                                </div>
                            </div>
                        </td>
                        <td class="text-center prevent-click">
                            <div class="relative flex items-center justify-center prevent-click" data-te-dropdown-position="dropstart">
                                <button type='button' className="list-more-btn prevent-click" href="#"
                                    id={tableData.student_id}
                                    // disabled={(userCognitoEmail === tableData.email_address) ? true : false}
                                    onClick={() =>handelActionButton(indexNum) }
                                    data-te-dropdown-toggle-ref
                                    aria-expanded="false"
                                    data-te-ripple-init
                                    // disabled={() => handelActionButton()}
                                    data-te-ripple-color="light">
                                    <img loading="lazy" decoding="async" src="/images/listAction.svg" alt="icon" class="prevent-click"/>
                                </button>
                                {selectedIndex===indexNum&& <ul ref={selectedRef} className={`${(indexNum+1 === 10 || indexNum+2 === 10) ? (tableData.status === "active" ?(isInactiveBranch ? "top1":"top2"):"top1"): ''} list-more-optns-div [&[data-te-dropdown-show]]:block prevent-click`} aria-labelledby="dropdownMenuButton2" data-te-dropdown-menu-ref>
                                    <>
                                        <li title="View GRN Entries">
                                            <AnimatedButton
                                                handleClick={() => {}}
                                                // handleClick={handleEditClick}
                                                buttonName={"View GRN Entries"}
                                                link={`/inventory-master/inventory-list/view-grn?${urlParams.toString()}&inventory_id=${tableData._id}&inventory_name=${tableData.item_name}&inventory_code=${tableData.item_code}`}
                                                className="list-more-optns prevent-click" />
                                        </li>
                                        {tableData.status === "active" && !isInactiveBranch && <>
                                            <li title="Edit Inventory">
                                                <AnimatedButton
                                                    handleClick={() => {}}
                                                    // handleClick={handleEditClick}
                                                    buttonName={"Edit Inventory"}
                                                    link={`/inventory-master/inventory-list/edit-inventory/${tableData._id}?${urlParams.toString()}`}
                                                    className="list-more-optns prevent-click" />
                                            </li>
                                            <li title="Deactivate">
                                                <AnimatedButton
                                                    handleClick={handleConformationClick}
                                                    buttonName={"Deactivate"}
                                                    // link={`/student-master/directory/${tableData._id}?${searchParams.toString()}`}
                                                    className="list-more-optns prevent-click" />
                                            </li>
                                        </>}
                                        
                                    </>     
                                </ul>}
                            </div>
                        </td>
                    </>
                    
                }/>
          
            
            {activateOpen && 
            <AnimatedModel
                Children={
                    <ConfirmationPrompt
                        handleOnCLickActivate={handleOnCLickActivate}
                        handleClose={handleConformationClick}
                        tittle= {`Deactivate Item`}
                        message = {`Are you sure you want to deactivate the inventory item '${tableData?.item_name}' ?`}
                        buttonName = {`Deactivate`}
                        loadingActivation={activateButtonLoading}
                    />
                }
            />  
            }
        </>
        
    );
}

export default TableBody;
